import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedCompanyTerritoireUserApiService } from './company-territoire-user-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyTerritoireUserApiService extends GeneratedCompanyTerritoireUserApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
